import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../../store/config/types';
import { connect, ConnectedProps } from 'react-redux';
import * as actions from '../../store/actions/toast.actions';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { authService } from '../../services/auth.service';
import { ShipperUser } from '../../store/config/types/shipperUser.types';

const mapStateToProps = (state: RootState) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, any>) => ({
  setToast: (message: string, messageType: string) => dispatch(actions.setToast(message, messageType)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector> & {
  open: boolean;
  adminMode?: boolean;
  user?: ShipperUser | null;
  // eslint-disable-next-line
  onClose: (doLogout?: boolean) => void;
};

function ChangePassword({ auth, open, adminMode, user, onClose, setToast }: PropsFromRedux) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>();
  const handleChangePassword = () => {
    setErrorMessage(undefined);
    if ((adminMode || currentPassword) && newPassword && newPassword === confirmPassword) {
      authService
        .changePassword(user?.shipperUserId, currentPassword, newPassword)
        .then(() => {
          setToast('Password changed.', 'info');
          handleClose(true);
        })
        .catch((err) => {
          setErrorMessage(err.message || 'Failed.');
        });
    }
  };
  const handleClose = (doLogin?: boolean) => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setErrorMessage('');
    onClose(!adminMode && doLogin);
  };
  return (
    <Dialog open={open} onClose={() => handleClose()}>
      <DialogTitle>{adminMode ? user?.email : auth?.account?.email}</DialogTitle>
      <DialogContent>
        {!adminMode && (
          <TextField
            label="Current Password"
            type="password"
            fullWidth
            margin="normal"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        )}
        <TextField
          label="New Password"
          type="password"
          fullWidth
          margin="normal"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          label="Confirm New Password"
          type="password"
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {errorMessage && (
          <Typography variant="caption" color="error">
            {errorMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()}>Cancel</Button>
        <Button
          onClick={handleChangePassword}
          variant="contained"
          color="primary"
          disabled={!(currentPassword || adminMode) || !newPassword || newPassword != confirmPassword}
        >
          Change Password
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default connector(ChangePassword);
